"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findRouteMetas = exports.importAll = exports.stringToBlob = exports.permissionAllowed = exports.isSenderAllowed = exports.urlToOrigin = exports.fakeBrowserAction = exports.requireAuth = exports.rejectAuth = exports.checkAuth = exports.logOut = exports.cloneDeep = exports.formatTime = exports.localizeString = exports.isDev = exports.getEnv = exports.getStore = exports.getVm = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
const lodash_clonedeep_1 = tslib_1.__importDefault(require("lodash.clonedeep"));
const lodash_mergewith_1 = tslib_1.__importDefault(require("lodash.mergewith"));
const lodash_replace_1 = tslib_1.__importDefault(require("lodash.replace"));
const vue_oop_1 = require("vue-oop");
const jwt_1 = tslib_1.__importDefault(require("./jwt"));
function getVm() {
    return vue_oop_1.Registry.getInstance().get('Vue');
}
exports.getVm = getVm;
function getStore() {
    var _a;
    return (_a = getVm()) === null || _a === void 0 ? void 0 : _a.$store;
}
exports.getStore = getStore;
function getEnv(key) {
    return process.env[key] || '';
}
exports.getEnv = getEnv;
function isDev() {
    return getEnv('NODE_ENV').toLowerCase() === 'dev'
        || getEnv('NODE_ENV').toLowerCase() === 'development'
        || getEnv('NODE_ENV').toLowerCase() === 'local';
}
exports.isDev = isDev;
function localizeString(slug, ...substitutions) {
    if (window.chrome) {
        return window.chrome.i18n ? window.chrome.i18n.getMessage(slug, ...substitutions) : `${slug} ${substitutions.join(',')}`;
    }
    if (!window.i18n) {
        return slug;
    }
    let value = lodash_get_1.default(window.i18n, slug);
    if (substitutions) {
        Array.from(substitutions).forEach((paramKey, paramVal) => {
            value = lodash_replace_1.default(value, `:${paramVal}`, paramKey);
        });
    }
    return value || slug;
}
exports.localizeString = localizeString;
function formatTime(milliseconds, { showEmptyHours = true, showEmptyMinutes = true, showSeconds = true, showSuffix = false, } = {}) {
    const hours = moment_1.default.duration(Math.abs(milliseconds)).asHours();
    const truncHours = Math.trunc(hours);
    const minutes = moment_1.default.duration((hours % 1) * 60 * 60 * 1000).asMinutes();
    const truncMinutes = Math.trunc(minutes);
    let seconds = 0;
    if (showSeconds) {
        seconds = moment_1.default.duration((minutes % 1) * 60 * 1000).asSeconds();
    }
    let hoursFmt = '';
    let minutesFmt = '';
    if (showEmptyHours || truncHours) {
        hoursFmt = `${truncHours}`;
    }
    if (showEmptyMinutes || truncMinutes) {
        minutesFmt = `${truncMinutes}`;
        if (showEmptyHours || truncHours) {
            minutesFmt = `:${String(truncMinutes).padStart(2, '0')}`;
        }
    }
    let secondsFmt = '';
    if (showSeconds) {
        secondsFmt = `:${(String(Math.trunc(seconds))).padStart(2, '0')}`;
    }
    const fullString = `${hoursFmt}${minutesFmt}${secondsFmt}`;
    if (showSuffix) {
        if (!fullString) {
            return milliseconds < 0
                ? localizeString('less_min_left')
                : localizeString('less_min_overtime');
        }
        let msgOvertime = 'min_overtime';
        let msgLeft = 'min_left';
        if (truncHours) {
            msgOvertime = 'hr_overtime';
            msgLeft = 'hr_left';
        }
        return milliseconds < 0
            ? localizeString(msgOvertime, fullString)
            : localizeString(msgLeft, fullString);
    }
    return fullString;
}
exports.formatTime = formatTime;
function cloneDeep(obj) {
    return lodash_clonedeep_1.default(obj);
}
exports.cloneDeep = cloneDeep;
function logOut() {
    jwt_1.default.clear();
    sessionStorage.clear();
    localStorage.clear();
}
exports.logOut = logOut;
function checkAuth() {
    return jwt_1.default.retrieve().catch(() => false);
}
exports.checkAuth = checkAuth;
function rejectAuth(to, from, next) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const isAuth = yield checkAuth();
        if (isAuth) {
            return next({ name: 'home' });
        }
        logOut();
        return next();
    });
}
exports.rejectAuth = rejectAuth;
function requireAuth(to, from, next) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const isAuth = yield checkAuth();
        if (isAuth) {
            return next();
        }
        logOut();
        return next({ name: 'index' });
    });
}
exports.requireAuth = requireAuth;
exports.fakeBrowserAction = {
    setBadgeText({ text }) {
        console.log(`Setting browser action badge with text: ${text}`);
    },
    setBadgeBackgroundColor({ color }) {
        console.log(`Setting browser action badge with color: ${color}`);
    },
};
function urlToOrigin(url) {
    const { hostname } = new URL(url);
    const origin = `*://${hostname}/*`;
    return {
        hostname,
        origin,
        permission: { origins: [origin] },
    };
}
exports.urlToOrigin = urlToOrigin;
function isSenderAllowed({ url }) {
    const { matches } = window.chrome.runtime.getManifest().externally_connectable;
    return matches.includes(urlToOrigin(url).origin);
}
exports.isSenderAllowed = isSenderAllowed;
function permissionAllowed(permission) {
    return new Promise((resolve, reject) => {
        window.chrome.permissions.contains(permission, (granted) => (granted ? resolve(true) : reject(new Error(`No permissions for ${permission}`))));
    });
}
exports.permissionAllowed = permissionAllowed;
function stringToBlob(base64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        const begin = sliceIndex * sliceSize;
        const end = Math.min(begin + sliceSize, bytesLength);
        const bytes = new Array(end - begin);
        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}
exports.stringToBlob = stringToBlob;
function importAll(files) {
    const children = [];
    let notFound;
    files.keys().forEach((key) => {
        if (key.includes('not-found.js')) {
            notFound = files(key).default;
            return;
        }
        children.push(files(key).default);
    });
    if (notFound) {
        children.push(notFound);
    }
    return children;
}
exports.importAll = importAll;
function findRouteMetas(route) {
    return route.matched.map(m => m.meta)
        .reduce((accumulator, current) => lodash_mergewith_1.default(accumulator, current, (objValue, srcValue) => (Array.isArray(objValue) ? objValue.concat(srcValue) : objValue)), {});
}
exports.findRouteMetas = findRouteMetas;
//# sourceMappingURL=helpers.js.map